/** Human-readable labels for quote sub-limit keys (shared by compare/detail UIs). */
export const SUB_LIMIT_LABELS = {
  computer: "Computer",
  fundsTransferFraud: "Funds Transfer Fraud",
  hardwareReplacement: "Hardware Replacement",
  postBreachRemediation: "Post Breach Remediation",
  socialEngineering: "Social Engineering",
  telecomFraud: "Telecommunications Fraud",
  websiteMediaContentLiability: "Website Media Content Liability",
  serviceFraudAndCryptojacking: "Service Fraud and Cryptojacking",
  dedicatedBreachCosts: "Dedicated Breach Costs",
  notificationOutsideLimit: "Notification Outside the Limit",
  socialEngineeringDeductible: "Social Engineering Deductible",
};

// Shown for a failed carrier request that has no reason a person can read.
export const FAILED_LEG_DEFAULT_REASON = "The underwriter could not process this request. Try Resubmit.";

// A failed reason ends with "Try Resubmit." when the broker can resubmit. Where the
// submission stays open for other carriers there is no such button, so the hint goes.
export const stripResubmitHint = (reason) =>
  String(reason || "")
    .replace(/\s*Try Resubmit\.?$/i, "")
    .trim();

// Shown for a failed bind whose reason a person cannot read.
export const BIND_FAILED_DEFAULT_REASON = "The underwriter could not complete this bind.";
